import { useEffect, useRef, useState } from "react";
import { heroServices } from "../../../../services/hero";
import { useAsync } from "../../../../utils/hooks/useAsync";
import "./AdminHero.scss";
import Label from "../../../Label";
import AdminHeroImages from "./AdminHeroImages";
import { toast } from "react-toastify";
import { AdminService } from "../../utils";
import Loading from "../../../common/Loading";

const AdminHeroContainer = () => {
  const {
    data: heroImages,
    isSuccess,
    run,
    isLoading,
  } = useAsync<Hero[], string>();
  const [action, setAction] = useState<boolean>(true);
  const [image, setImage] = useState<FormData>();
  const [mobileHero, setMobileHero] = useState<boolean>(false);

  useEffect(() => {
    run(heroServices.getHero()).then(() => setAction(false));
  }, []);

  const changeHandler = async (event: any) => {
    const file = event.currentTarget.files[0];
    const data = new FormData();
    data.append("image", file);
    data.append("mobileHero", JSON.stringify(mobileHero));
    setImage(data);
  };
  useEffect(() => {
    image && saveImage();
  }, [image]);

  const saveImage = () => {
    setAction(true);
    toast.warning("Subiendo la imagen");
    image &&
      run(AdminService.saveHeroImage(image)).then((r: any) => {
        toast.success("Imagen guardada");
        run(heroServices.getHero()).then(() => setAction(false));
      });
  };

  const handleDelete = (imageDelete: string) => {
    setAction(true);
    run(
      AdminService.deleteHeroImage({
        image: imageDelete,
      })
    ).then((r: any) => {
      run(heroServices.getHero()).then(() => setAction(false));
      toast.success("Imagen borrada");
    });
  };

  return (
    <div className="uploadImage_Container uploadHeroImage_Container">
      {isLoading && <Loading />}
      <div className="uploadImageHeader">
        <Label
          tag="h1"
          style={{
            textAlign: "left",
            fontFamily: "Mont-Semibold",
            fontSize: "26px",
          }}
        >
          Slider Home
        </Label>
      </div>
      {!action && heroImages && (
        <AdminHeroImages
          heroImages={heroImages}
          changeHandler={changeHandler}
          handleDelete={handleDelete}
          setMobileHero={setMobileHero}
        />
      )}
    </div>
  );
};

export default AdminHeroContainer;
